import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SectionImg from '../SectionImg';
import Agency from './Agency';
import StorageInterface from "../../api scripts/storageInterface";
import localCoursesData from "../../data/coursesData";


const collapseHandler = (agencyName) => {
  const elem = document.getElementById(`${agencyName}categoriesContainer`);
  const header = document.querySelector(`#${agencyName}wrapper .coursesAgencyNameHeader`);
  
  if (elem && header) {
    const isCollapsed = elem.classList.contains('collapse');
    
    if (isCollapsed) {
      // Expanding
      elem.classList.remove('collapse');
      elem.style.height = '0px';
      
      // Get the natural height
      const naturalHeight = elem.scrollHeight;
      
      // Force a reflow to ensure the height change is applied
      const forceReflow = elem.offsetHeight; // eslint-disable-line no-unused-vars
      
      // Animate to natural height
      elem.style.height = naturalHeight + 'px';
      
      // Clean up after animation completes
      const cleanup = () => {
        if (!elem.classList.contains('collapse')) {
          elem.style.height = 'auto';
        }
        elem.removeEventListener('transitionend', cleanup);
      };
      
      elem.addEventListener('transitionend', cleanup);
      
    } else {
      // Collapsing
      // Set explicit height first
      elem.style.height = elem.scrollHeight + 'px';
      
      // Force reflow
      const forceReflow = elem.offsetHeight; // eslint-disable-line no-unused-vars
      
      // Animate to 0
      elem.style.height = '0px';
      elem.classList.add('collapse');
    }
  }
}

// Function to expand all agency containers
const expandAllAgencies = () => {
  const agencyContainers = document.querySelectorAll('.coursesCategoriesContainer');
  agencyContainers.forEach(container => {
    if (container.classList.contains('collapse')) {
      const agencyName = container.id.replace('categoriesContainer', '');
      collapseHandler(agencyName);
    }
  });
};

 
const Courses = () => {
  const { agency } = useParams();
  const [courseData, setCourseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch courses data from S3
  useEffect(() => {
    const fetchCoursesData = async () => {
      try {
        const data = await StorageInterface.downloadData(null, 'coursesData/');
        
        // Check if data is error message
        if (data && data.line1) {
          console.error('[Courses] Error fetching data:', data);
          setCourseData(localCoursesData);
        } else if (data && Array.isArray(data) && data.length > 0) {
          // Successfully got data from S3
          setCourseData(data[0]);
        } else {
          // Fallback to local data
          setCourseData(localCoursesData);
        }
      } catch (err) {
        console.error('[Courses] Error fetching courses:', err);
        // Fallback to local data
        setCourseData(localCoursesData);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCoursesData();
  }, []);

  // Handle agency-specific expand/collapse
  useEffect(() => {
    // Only run this effect after data has finished loading
    if (isLoading) return;
    
    if (agency) {
      // Navigated from About page with specific agency
      // Add a small delay to ensure the DOM is fully rendered
      const timer = setTimeout(() => {
        // First collapse all agencies
        const agencyContainers = document.querySelectorAll('.coursesCategoriesContainer');
        agencyContainers.forEach(container => {
          if (!container.classList.contains('collapse')) {
            const agencyName = container.id.replace('categoriesContainer', '');
            collapseHandler(agencyName);
          }
        });
        
        // Then expand the specific agency
        setTimeout(() => {
          collapseHandler(agency);
          // Scroll to the agency section
          const agencyElement = document.getElementById(`${agency}wrapper`);
          if (agencyElement) {
            agencyElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }, 100);
      
      return () => clearTimeout(timer);
    } else {
      // Direct load - expand all agencies
      const timer = setTimeout(() => {
        expandAllAgencies();
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [agency, isLoading]);

  return (
    <div className="courses">
      <SectionImg title="Our Courses" pageName="Courses" imgClass="defaultSectionImg" />
      <div className="coursesContainer">
        <div className="courses-image-section">
          <img 
            className="coursesImg" 
            alt="Students learning about safety in professional training environment" 
            src={require("./..\\..\\Assets\\images\\thumbnail_IMG_5658.jpg")} 
          />
        </div>
        <div className="coursesWrapper">
          <div className="courses-intro">
            <h2>Professional Safety Training</h2>
            <p>We provide comprehensive safety training courses authorized by leading agencies. Our expert instructors deliver high-quality education to help you meet compliance requirements and enhance workplace safety.</p>
          </div>
          {isLoading ? (
            <>
              <div className="courses-loading-overlay">
                <div className="courses-loading-message">
                  <p>Loading courses...</p>
                </div>
              </div>
              <div className="courses-skeleton-container">
                <div className="coursesAgencyWrapper courses-skeleton">
                  <h3 className="coursesAgencyNameHeader">Safety Training Agency</h3>
                  <div className="coursesCategoriesContainer">
                    <div className="categoryWrapper">
                      <h4>Professional Development</h4>
                      <p>Comprehensive training programs designed to enhance workplace safety knowledge and skills.</p>
                    </div>
                  </div>
                </div>
                <div className="coursesAgencyWrapper courses-skeleton">
                  <h3 className="coursesAgencyNameHeader">Certification Programs</h3>
                  <div className="coursesCategoriesContainer">
                    <div className="categoryWrapper">
                      <h4>Advanced Safety Courses</h4>
                      <p>Industry-leading certifications for safety professionals and compliance officers.</p>
                    </div>
                  </div>
                </div>
                <div className="coursesAgencyWrapper courses-skeleton">
                  <h3 className="coursesAgencyNameHeader">Specialized Training</h3>
                  <div className="coursesCategoriesContainer">
                    <div className="categoryWrapper">
                      <h4>Technical Skills Development</h4>
                      <p>Hands-on training for specialized safety equipment and procedures.</p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <Agency courseData={courseData} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Courses;